// Bottom Navigation - Now used for all screen sizes
import React from 'react';
import { cn } from '@/lib/utils';
import Container from '@/components/ui/Container';
import MobileBottomNav from './MobileBottomNav';

const BottomNav = () => {
  // TEMPORARILY HIDDEN: Bottom navigation is temporarily hidden
  // To restore: Remove the "hidden" class from the Container element below
  // Original state: Bottom navigation was always visible on all screen sizes
  return (
    <Container>
      <div className="flex h-16 items-center justify-between">
        <MobileBottomNav />
      </div>
    </Container>
  );
};

export default BottomNav;
